import {
  onAddDocumentPDF,
  onAllResetState,
  onChangeNumPages,
  onChangePageNo,
  onChangeScale,
  onDocumentoSeleccionado,
  onShowVisor,
  onAddDocumentos,
  onPosicion,
  onAddOpenVisor,
  onAddPaginaActual,
  onChangeRotation,
  onChangeExpandir,
  onChangeUltimaPag,
  onChangePrimeraPag,
  onAddActuaciones,
  onAddArbolVisor,
  onAddNodoSelect,
  onAddEncabezadoLaboralPenal,
  onPosicionLaboral,
  onPosicionPenal,
  onAddNodoLabPenal,
  onDocumentoSeleccionadoCentrales,
  onChangeVerDetallesElect,
  onAddDatosPA,
} from "store/visorDocumentos/visorDocumentosSlice";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import {
  getDocumentosCentralesService,
  getDocumentosCentralesServiceNoBuffer,
} from "services/serviciosGenerales/serviciosGenerales";
import { useUiStore } from "./useUiStore";
import Swal from "sweetalert2";
import { listaErrores } from "helpers/helpers";
import { getObtenerTodosDocumentos, getObtenerTodosDocumentosZIP } from "services/actuacionesPDFService/actuacionPdfService";


export const useVisorDocumentosStore = () => {
  const dispatch = useAppDispatch();
  const { loadingBackdrop, addMessageSnackBmessageSnackBar } = useUiStore();
  const {
    documentSelected,
    openVisor,
    numPages,
    pageNo,
    scale,
    documentoSeleccionado,
    documentos,
    posicion,
    abrirVisor,
    paginaActual,
    rotation,
    expandir,
    ultimaPag,
    primeraPag,
    lstActuaciones,
    arbolData,
    nodoSelect,
    encabezadoLaboralPenal,
    posicionLaboral,
    posicionPenal,
    nodoLaboralPenal,
    documentoSeleccionadoCentrales,
    verDetallesElecttonico,
    datosPA,
  } = useAppSelector((state) => state.visorDocumentos);

  const addDocumentos = (files: any) => dispatch(onAddDocumentos(files))
  const addPosicion = (pos: number) => dispatch(onPosicion(pos))
  const addPosicionLaboral = (pos: number) => dispatch(onPosicionLaboral(pos))
  const addPosicionPenal = (pos: number) => dispatch(onPosicionPenal(pos))
  const openVisorDocumentos = (status: boolean) =>
    dispatch(onShowVisor(status));
  const addDocumentPDF = (pdf: string[]) => dispatch(onAddDocumentPDF(pdf));
  const changeNumPages = (pages: number) => dispatch(onChangeNumPages(pages));
  const changePageNo = (page: number) => dispatch(onChangePageNo(page));
  const changeScale = (scale: number) => dispatch(onChangeScale(scale));
  const changeRotation = (rotation: number) => dispatch(onChangeRotation(rotation));
  const addDocumentoSeleccionado = (documento: string) =>
    dispatch(onDocumentoSeleccionado(documento));
  const addDocumentoSeleccionadoCentrales = (documento: string) =>
    dispatch(onDocumentoSeleccionadoCentrales(documento));
  const resetAllState = () => dispatch(onAllResetState());
  const addActuaciones = (actuacion: any) => dispatch(onAddActuaciones(actuacion));
  const addArbolVisor = (files: []) => dispatch(onAddArbolVisor(files));
  const addNodoSelect = (files: any) => dispatch(onAddNodoSelect(files));
  const addNodeLabPenal = (files: any) => dispatch(onAddNodoLabPenal(files));
  const addDatosPA = (data: any) => dispatch(onAddDatosPA(data));

  const startGetDocumentosCentrales = (idActuacion: number) => {
    addDocumentoSeleccionadoCentrales("")
    getDocumentosCentralesService(idActuacion)
      .then(({ data }) => {
        const fileUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        addDocumentoSeleccionadoCentrales(fileUrl);
        addDocumentoSeleccionado(fileUrl)
        addDocumentos([fileUrl])
        addDocumentPDF([fileUrl])
        addPosicion(0)
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("Obteniendo Documentos");
      })
      .catch((err) => {

        getDocumentosCentralesServiceNoBuffer(idActuacion).catch((error) => {
          loadingBackdrop(false);
          addMessageSnackBmessageSnackBar("");
          Swal.fire({
            title: `¡Cuidado!`,
            text: error?.response?.data?.error_msg || "Hubo un problema",
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#6e7881",
            html: `
            <style>
            h4, h5{
              font-family: arial;
              color: #545454;
              text-align: center;
            }
            </style>
            <strong>  <h3>${error.response.data?.error_msg || "Hubo un problema"
              }</h3> </strong>
            <h5>${error?.response?.data?.error_data || "Hubo un problema"}</h5>
            <div id="lista-errores"></div>
            `,
          });
          listaErrores(error);
        });
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("");
      });
  };

  const startDescargarTodoDocPDF = (idReferencia: {}, nombreArchivo: string) => {
    if (idReferencia) {
      loadingBackdrop(true);
      addMessageSnackBmessageSnackBar("Descargando Documentos");
    }
    getObtenerTodosDocumentos(idReferencia)
      .then((response) => {
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("");
        const pdf = new Blob([response?.data], { type: "application/pdf" });
        const url = URL.createObjectURL(pdf);
        const a = document.createElement("a");
        a.href = url;
        a.download = nombreArchivo + ".pdf";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("");
        if (error?.response?.status === 500) {
          Swal.fire({
            title: `¡Cuidado!`,
            icon: "warning",
            html: `
            <style>
              h5{
            font-family: arial;
          color: #545454;
          text-align: center;
        }
        </style>
          <strong> <h3>Hubo un problema con la descarga del PDF.</h3> </strong>
          <h5>¿Desea descargarlo como .ZIP?</h5>
              `,
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#b61d2d",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            cancelButtonColor: "#6e7881",
          }).then((result) => {
            if (result.isConfirmed) {
              startDescargarTodoDocZIP(idReferencia, nombreArchivo);
            }
          });

        } else {
          Swal.fire({
            title: `¡Cuidado!`,
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#6e7881",
            html: `
            <style>
              h5{
            font-family: arial;
          color: #545454;
          text-align: center;
        }
        </style>
          <strong strong > <h3>${"Hubo un problema al descargar los documentos."
              } </h3> </strong>
          <h5>${error?.response?.statusText === "Not Found" ? "No se encontraron las Imagenes" : error?.response?.statusText} </h5>
              `,
          });
        }
      });
  }

  const startDescargarTodoDocZIP = (idReferencia: {}, nombreArchivo: string) => {
    if (idReferencia) {
      loadingBackdrop(true);
      addMessageSnackBmessageSnackBar("Descargando Documentos");
    }
    getObtenerTodosDocumentosZIP(idReferencia)
      .then((response) => {
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("");
        const zip = new Blob([response?.data], { type: "application/zip" });
        const url = URL.createObjectURL(zip);
        const a = document.createElement("a");
        a.href = url;
        a.download = nombreArchivo + ".zip";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        loadingBackdrop(false);
        addMessageSnackBmessageSnackBar("");
        Swal.fire({
          title: `¡Cuidado!`,
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
            <style>
              h5{
            font-family: arial;
          color: #545454;
          text-align: center;
        }
        </style>
          <strong strong > <h3>${"Hubo un problema al descargar los documentos."
            } </h3> </strong>
          <h5>${error?.response?.statusText === "Not Found" ? "No se encontraron las Imagenes" : error?.response?.statusText} </h5>
              `,
        });
      });
  }




  const onAddOpenVisorLibro = (abrirLibro: boolean) => dispatch(onAddOpenVisor(abrirLibro));
  const onAddPaginaActualLibro = (pag: number) => dispatch(onAddPaginaActual(pag));
  const onAddChangeExpandir = (exp: boolean) => dispatch(onChangeExpandir(exp));
  const onChangeUltimaPagina = (value: boolean) => dispatch(onChangeUltimaPag(value));
  const onChangePrimeraPagina = (value: boolean) => dispatch(onChangePrimeraPag(value));
  const onChangeEncabezadoLaboralPenal = (value: any) => dispatch(onAddEncabezadoLaboralPenal(value));
  const onAddChangeVerDetallesElect = (data: boolean) => dispatch(onChangeVerDetallesElect(data));


  return {
    /**properties */
    openVisor,
    numPages,
    pageNo,
    scale,
    documentSelected,
    documentoSeleccionado,
    documentos,
    posicion,
    abrirVisor,
    paginaActual,
    rotation,
    expandir,
    ultimaPag,
    primeraPag,
    lstActuaciones,
    arbolData,
    nodoSelect,
    encabezadoLaboralPenal,
    posicionLaboral,
    posicionPenal,
    nodoLaboralPenal,
    documentoSeleccionadoCentrales,
    verDetallesElecttonico,
    datosPA,
    /**methods */
    addDocumentPDF,
    changeNumPages,
    changePageNo,
    changeScale,
    openVisorDocumentos,
    resetAllState,
    addDocumentoSeleccionado,
    startGetDocumentosCentrales,
    addDocumentos,
    addPosicion,
    onAddOpenVisorLibro,
    onAddPaginaActualLibro,
    changeRotation,
    onAddChangeExpandir,
    onChangeUltimaPagina,
    onChangePrimeraPagina,
    onChangeEncabezadoLaboralPenal,
    addNodoSelect,
    addNodeLabPenal,
    addActuaciones,
    addArbolVisor,
    addPosicionLaboral,
    addPosicionPenal,
    onAddChangeVerDetallesElect,
    addDatosPA,
    startDescargarTodoDocPDF,
    startDescargarTodoDocZIP,
  };
};
